/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object";

export default ($axios: any): any => ({
    // 가이드 목록
    async index(data?: any) {
        return camelize(await $axios.get(`/size`, snakelize({ params: data })));
    },
});
